module.exports = __webpack_public_path__ + "img/prev.5c6ee12e.svg";